module.exports = __webpack_public_path__ + "img/img_scan_error.4c3f1126.png";